import styles from './style.module.scss';
import { Space, Descriptions, Spin } from 'antd';
import { Button, PageHeader } from 'components';
import { DownloadOutlined } from '@ant-design/icons';
import { EditIcon } from 'icons';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import useBoardDocs from '../useBoardDocs';
import UIHelper from '../../../../../helpers/UIHelper';

const Single = () => {
  const { singleItem, handleDownload } = useBoardDocs(false);
  const { t } = useTranslation();

  const title = t('CIRCOLARI');

  return singleItem ? (
    <div>
      <PageHeader title={title}>
      </PageHeader>
      <div className={styles.content}>
        <Descriptions column={1} bordered>
          <Descriptions.Item label={t('Village')}>
            {singleItem?.shopping_center?.title}
          </Descriptions.Item>
          <Descriptions.Item label={t('Titolo')}>
            {singleItem?.title}
          </Descriptions.Item>
          <Descriptions.Item label={t('Data Pubblicazione')}>
            {UIHelper.formatedDate(singleItem?.date)}
          </Descriptions.Item>
          <Descriptions.Item label={t('File')}>
            <Space>
              <Button
                type={'primary-white'}
                onClick={() =>
                  handleDownload(singleItem?.file_url, singleItem?.file_name, singleItem?.title)
                }
                icon={<DownloadOutlined />}
              >
                Scarica file
              </Button>
            </Space>
          </Descriptions.Item>
        </Descriptions>
      </div>
    </div>
  ) : (
    <Spin size={'large'} />
  );
};

export default Single;
